"use client";

import { SocialProofAvatars } from "@/components/molecules/SocialProofAvatars";
import { InfoText } from "@/components/molecules/InfoText";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

export const TopPageTotalRecommendations = ({
    mapName,
    recommendationsCountOnPage,
    lastActivity,
}) => {
    return (
        <>
            <div
                className="mb-1 md:pr-10"
                onClick={() => trackItemTapped(MixpanelValues.ItemTapped.GLUTEN_FREE_REC_COUNT)}
                id="community-modal-trigger-recommendations">
                <SocialProofAvatars
                    count={3}
                    totalCount={recommendationsCountOnPage}
                    avatarsBorderColor="white"
                />
            </div>
            <InfoText
                lastActivity={lastActivity}
                mapName={mapName}
            />
        </>
    );
};
